import * as React from 'react';
import { MessageSquare, ChevronRight } from 'lucide-react';

/* Dark "Message Us" hero card at the top of the Help tab.
   Per v9 spec 6.1/6.2: the only black/navy card in the whole app. */
export function MessageUsCard({ unreadCount = 0, onClick }) {
  const hasUnread = unreadCount > 0;
  const subtitle = hasUnread
    ? 'We have a new reply — tap to continue the conversation.'
    : 'Questions, problems, ideas — we read every message.';

  return (
    <button
      type="button"
      onClick={onClick}
      className="w-full p-3 mb-3 text-left rounded-2xl bg-slate-900 text-white hover:bg-slate-800 transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-slate-900 focus-visible:ring-offset-2"
    >
      <div className="flex items-start gap-3">
        <div
          className="w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0 relative"
          style={{ background: 'rgba(255,255,255,0.12)' }}
        >
          <MessageSquare className="w-5 h-5" strokeWidth={2} />
          {hasUnread && (
            <span
              className="absolute -top-1 -right-1 min-w-[18px] h-[18px] px-1 rounded-full text-[10px] font-bold flex items-center justify-center"
              style={{ background: '#ef4444', color: '#fff' }}
            >
              {unreadCount}
            </span>
          )}
        </div>
        <div className="flex-1 min-w-0">
          <div className="text-[16px] font-semibold mb-0.5">Message Us</div>
          <div
            className="text-[12px] leading-relaxed"
            style={{ color: 'rgba(255,255,255,0.7)' }}
          >
            {subtitle}
          </div>
        </div>
        <ChevronRight
          className="w-4 h-4 flex-shrink-0 mt-1"
          style={{ color: 'rgba(255,255,255,0.6)' }}
          strokeWidth={2}
        />
      </div>
    </button>
  );
}

export default MessageUsCard;
